import Swal from "sweetalert2";

export type ShowDangerAlertProps = {
  text: string;
  confirmButtonText?: string;
  onConfirm?: () => void;
};

export const ShowDangerAlert = ({
  text,
  confirmButtonText = "OK",
  onConfirm,
}: ShowDangerAlertProps) => {
  Swal.fire({
    icon: "error",
    title: "Warning",
    text,
    confirmButtonText,
    confirmButtonColor: "var(--theme-default)",
  }).then((result) => {
    if (result.isConfirmed && onConfirm) {
      onConfirm();
    }
  });
};
